export enum FilterType {
  Demographic = "Demographic",
  Topics = "Topics",
  Threshold = "Threshold",
  Alerts = "Alerts",
  Feedback = "Feedback",
  UserDemographic = "UserDemographic",
  PinnedComments = "PinnedComments",
}
